// extracted by mini-css-extract-plugin
export default {"misc-wrapper":"comingSoon_misc-wrapper__kX-1k"};